import React from 'react';
import { Route } from "react-router-dom";
import { BrowserRouter } from 'react-router-dom'

// Componentes
import MainNav from "./components/Nav_bar/main_navbar"
import Footer from './components/UI/footer'

//import VisorMain from './components/VisorMain/VisorMain'
import CardsMain from './components/CardsMain/CardsMain'




// Imágenes y CSS
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

/*
NUEVO PARA EL DEPLIEGUE CON EL WORDPRESS
HAY QUE DEPLEGARLO Y SUBIRLO 2 VECES, UNA CON LA RAIZ APUNTANDO A MAP_COMP
Y OTRA CON LA RAIZ APUNTANDO A EEI_FINDER
NO NOS OLVIDAMOS DE CAMBIAR EN EL MENU LAS URLS
*/


function App() {
  return (
    <div className="sliderhome">
      <BrowserRouter basename={'/'}>
          <MainNav />
            {/*<Route exact path={`${process.env.PUBLIC_URL}/`} component={VisorMain} />*/}
            <Route exact path={`${process.env.PUBLIC_URL}/`} component={CardsMain} />
          <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
